import { SVGProps } from "react";

export function DollarSign(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.75 9.3025V4.087C8.0175 4.297 9.063 4.9135 9.9165 5.971L11.0835 5.029C9.9435 3.6175 8.487 2.7985 6.75 2.572V0.25H5.25V2.5165C2.53875 2.6815 0.750004 4.2115 0.750004 6.4315C0.750004 9.637 3.09525 10.2715 5.25 10.6007V15.9715C3.21 15.8387 2.23575 15.1465 1.3335 14.029L0.166504 14.971C1.494 16.6157 2.96625 17.347 5.25 17.4738V19.75H6.75V17.4662C9.5445 17.2383 11.25 15.721 11.25 13.3862C11.25 10.2295 8.89275 9.625 6.75 9.3025ZM2.25 6.4315C2.25 4.81675 3.7725 4.141 5.25 4.02175V9.08125C3.3225 8.764 2.25 8.299 2.25 6.4315ZM6.75 15.964V10.8212C8.67525 11.1325 9.75 11.5742 9.75 13.3862C9.75 15.2882 8.1075 15.8357 6.75 15.964Z"
        fill="currentColor"
      />
    </svg>
  );
}
